<template>
    <div>
        <v-container>
            <v-row class="pb-2">
                <v-col justify="start">Alla dokument</v-col>
                <v-spacer></v-spacer>
                <v-col>
                    <v-btn
                        @click="clickBack()"
                        small
                        justify="end"
                        >Stäng</v-btn>
                </v-col>
            </v-row>

            <hr>
            <template v-for="document in documents">
                <v-row :key="document.uuid" class="mx-4 my-8" v-if="!document.internal">
                    <v-col class="ml-4" style="max-width:100px">
                        <a :href="$cdnConfig.baseUrl + document.contentUrl + '?access_token=' + $accessToken" target="_blank">
                            <template v-if="document.thumbUrl">
                                <v-img :src="$cdnConfig.baseUrl + document.thumbUrl + '?access_token=' + $accessToken" justify="start"></v-img>
                            </template>
                            <template v-else>
                                <v-img src="../assets/images/perfecta_full_logo.png" justify="start"></v-img>
                            </template>
                        </a>
                    </v-col>
                    <v-col class="ml-4" style="max-width:170px; word-wrap: break-word;">
                        <a :href="$cdnConfig.baseUrl + document.contentUrl + '?access_token=' + $accessToken" target="_blank">{{ document.fileName }}</a>
                    </v-col>
                </v-row>
            </template>
        </v-container>
    </div>
</template>

<script>
export default {
    name: 'Documents',
    props: {
        documents: {
            type: Array,
            required: true
        },
        jobId: {
            type: String,
            required: true
        },
        accessToken: {
            type: String,
            required: true
        }
    },
    data: () => ({
    }),
    methods: {
        clickBack() {
            this.$router.push({ path: '/job',  query: { job: this.$jobId, access_token: this.$accessToken } })
        }
    }
    
}
</script>
<style lang="scss" scoped>

</style>